


































import { Component, Prop, Vue } from 'vue-property-decorator'
import { Collection, View, ComponentType, Chart, ChartType } from '@/models'
import PaginatedList from '@/components/PaginatedList.vue'
import ComponentCreateDialog from '@/components/ComponentCreateDialog.vue'
import { CreateElement } from 'vue'
import gql from 'graphql-tag'
import * as ComponentTypes from '..'

@Component({
  components: {
    PaginatedList,
    ComponentCreateDialog
  },
  apollo: {
    chartTypes: gql`query {
      chartTypes {
        _id
        name
      }
    }`
  }
})
export default class AdminComponentsChartsList extends Vue {
  /** Current Environment ID */
  @Prop({ type: String, required: true }) environmentId !: string
  /** Current component type name */
  @Prop({ type: String, required: true }) componentTypeName !: string

  chartTypes !: ChartType[]

  /** Current search query */
  searchQuery = ''
  /** Current sorting mode */
  sortBy = 'name'
  /** Create modal state */
  createModalOpen = false

  /** Current component type */
  get componentType () : ComponentType<any> {
    return (ComponentTypes as Record<string, ComponentType<any>>)[this.componentTypeName]
  }

  transformResult (input : Chart) {
    const typeDef = this.chartTypes.find(t => t._id === input.chartTypeId)
    return {
      ...this.componentType.transformResult(input),
      subtitle: typeDef ? typeDef.name : input.chartTypeId
    }
  }

  /** Open or close the creation modal */
  toggleCreateModal (value : any) {
    this.createModalOpen = value != null && typeof value === 'boolean' ? value : !this.createModalOpen
  }

  handleCreate (component : any) {
    if (component && component._id) {
      return this.$router.push(`${this.componentType.namespace}/${component._id}`)
    }
  }
}
